import { classNames } from "../utils/classNames";
import { useTranslation } from "../stores/RootStoreContext";
import { Icon, IconProps } from "./Icon";

export const Spinner = ({ size, className }: { className?: string; size?: IconProps["size"] }) => {
  return (
    <Icon name={"circle-notch"} className={classNames("tw-animate-spin", className)} size={size} />
  );
};

export type LoadingIndicatorProps = {
  size?: "sm" | "md" | "lg";
  label?: string;
  fullscreen?: boolean;
};

export function LoadingIndicatorUI({ size, label, fullscreen }: LoadingIndicatorProps) {
  const containerClassNames = classNames(
    "tw-flex",
    "tw-gap-2",
    "tw-items-center",
    fullscreen && ["tw-absolute", "tw-inset-0", "tw-justify-center"],
  );
  switch (size) {
    case "sm":
      return (
        <div className={containerClassNames}>
          <Spinner size={"sm"} className={"color-primary"} />
          <div className={"text-sm"}>{label}</div>
        </div>
      );
    case "md":
      return (
        <div className={containerClassNames}>
          <Spinner size={"md"} className={"color-primary"} />
          <div>{label}</div>
        </div>
      );
    default:
      return (
        <div className={`${containerClassNames} tw-flex-col`}>
          <div className={"text-h3"}>{label}</div>
          <Spinner size={"xxl"} className={"color-primary"} />
        </div>
      );
  }
}

export function LoadingIndicator({ label, ...props }: LoadingIndicatorProps) {
  const { t } = useTranslation();
  return <LoadingIndicatorUI label={label ?? t("loading")} {...props} />;
}
